module.exports = __webpack_public_path__ + "static/media/cinnabon.7ecca189.jpg";